import { SVGProps, Ref, forwardRef } from 'react';

export const AZSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path d="M0 6a3 3 0 0 1 3-3h18a3 3 0 0 1 3 3v3H0z" fill="#0098C3" />
            <rect y={9} width={24} height={6} fill="#E00034" />
            <path d="M0 15h24v3a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3z" fill="#00AE65" />
            <path
                d="M9.48 12a2.197 2.197 0 0 0 3.83 1.472 2.637 2.637 0 1 1 0-2.943A2.197 2.197 0 0 0 9.48 12"
                fill="white"
            />
            <path
                d="m14.728 11.72.789.279-.789.28.36.756-.756-.359-.28.789-.28-.788-.004.001-.752.358.358-.755-.788-.28.788-.28-.36-.756.755.357.002.002.28-.789.28.788.756-.36z"
                fill="white"
            />
        </g>
    </svg>
));
AZSize24Glyph.displayName = 'AZSize24Glyph';
